'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _iso6391Zh = require('iso-639-1-zh');

var _iso6391Zh2 = _interopRequireDefault(_iso6391Zh);

var _iso31661Alpha = require('iso-3166-1-alpha-2');

var _iso31661Alpha2 = _interopRequireDefault(_iso31661Alpha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REG = /^([a-z]{2})-([A-Z]{2})$/;

var LocaleCode = function () {
  function LocaleCode() {
    (0, _classCallCheck3.default)(this, LocaleCode);
  }

  (0, _createClass3.default)(LocaleCode, null, [{
    key: 'getLanguageCode',

    /* language iso-639-1 */
    value: function getLanguageCode(code) {
      var match = code.match(REG);
      if (!match || match.length < 1) return '';
      return match[1];
    }
  }, {
    key: 'getLanguageName',
    value: function getLanguageName(code) {
      var languageCode = LocaleCode.getLanguageCode(code);
      return _iso6391Zh2.default.getName(languageCode);
    }
  }, {
    key: 'getLanguageNativeName',
    value: function getLanguageNativeName(code) {
      var languageCode = LocaleCode.getLanguageCode(code);
      return _iso6391Zh2.default.getNativeName(languageCode);
    }
  }, {
    key: 'getLanguageZhName',
    value: function getLanguageZhName(code) {
      var languageCode = LocaleCode.getLanguageCode(code);
      return _iso6391Zh2.default.getZhName(languageCode);
    }
  }, {
    key: 'validateLanguageCode',
    value: function validateLanguageCode(code) {
      var languageCode = LocaleCode.getLanguageCode(code);
      return _iso6391Zh2.default.validate(languageCode);
    }
  }, {
    key: 'getLanguages',
    value: function getLanguages(codes) {
      var list = [];
      for (var i = 0; i < codes.length; i++) {
        list.push({
          code: codes[i],
          name: LocaleCode.getLanguageName(codes[i]),
          nativeName: LocaleCode.getLanguageNativeName(codes[i]),
          zhName: LocaleCode.getLanguageZhName(codes[i])
        });
      }
      return list;
    }

    /* country iso-3166-1-alpha-2 */

  }, {
    key: 'getCountryCode',
    value: function getCountryCode(code) {
      var match = code.match(REG);
      if (!match || match.length < 2) return '';
      return match[2];
    }
  }, {
    key: 'getCountryName',
    value: function getCountryName(code) {
      var countryCode = LocaleCode.getCountryCode(code);
      return _iso31661Alpha2.default.getCountry(countryCode);
    }
  }, {
    key: 'validateCountryCode',
    value: function validateCountryCode(code) {
      code = LocaleCode.getCountryCode(code);
      if (_iso31661Alpha2.default.getCodes().indexOf(code) === -1) {
        return false;
      } else {
        return true;
      }
    }

    /* validate */

  }, {
    key: 'validate',
    value: function validate(code) {
      var match = code.match(REG);
      if (match && match.length === 3 && LocaleCode.validateLanguageCode(code) && LocaleCode.validateCountryCode(code)) {
        return true;
      } else {
        return false;
      }
    }
  }]);
  return LocaleCode;
}();

exports.default = LocaleCode;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = ./src/index.js
// module chunks = 0